<template>
  <div class="main" >
    <a-spin :spinning="flag">
      <a-form
          :form="form"
          class="user-layout-login"
          ref="formLogin"
          id="formLogin"
      />
    </a-spin>
    <register-modal ref="registerModal"></register-modal>
    <register-modal-si-chuan ref="registerModalSiChuan"></register-modal-si-chuan>
    <update-password-modal ref="updatePasswordModal"></update-password-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RegisterModal from "./RegisterModal.vue";
import RegisterModalSiChuan from "./RegisterModalSiChuan.vue";
import UpdatePasswordModal from "./UpdatePasswordModal.vue";
import { timeFix, getQueryString } from "@/utils/utils";
import { registerSiChuan} from "@/api/login";

import { initDynamicRoutes } from "@/router";
export default {
  name: "sso",

  components: { RegisterModal,UpdatePasswordModal,RegisterModalSiChuan },
  data() {
    return {
      customActiveKey: "tab1",
      loginBtn: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        smsSendBtn: false,
      },
      validatorRules: {
        username: {
          rules: [
            { required: true, message: "请输入用户名!" },
            { validator: this.handleUsernameOrEmail },
          ],
        },
        password: {
          rules: [
            { required: true, message: "请输入密码!", validator: "click" },
          ],
        },
        mobile: { rules: [{ validator: this.validateMobile }] },
        captcha: { rule: [{ required: true, message: "请输入验证码!" }] },
        inputCode: { rules: [{ required: true, message: "请输入验证码!" }] },
      },
      flag: false,
      errorShow: false,
      errorShowSiChuan: false,
      showModalSiChuan: false
    };
  },
  async  mounted() {
    /*
        let isSiChuan = location.host == "localhost:8081";
    */

    let isSiChuan = location.host == "test-zhdx.hthuiyou.com";

    if (isSiChuan) {

      let token = getQueryString("idToken");
      let target = getQueryString("target");
      const decodedTarget = decodeURIComponent(target); // 确保 target 已解码
      if (token) {
        if (!token && decodedTarget =="") {

          this.handleSiChuanError();
        } else {
          //验证是否要打开注册页面
          try {
            // 异步操作开始
            this.registerSiChuan(token,decodedTarget)
                .then(() => {
                  // 异步操作完成后执行路由跳转
                  //this.$router.push("/taxRiskControl");
                })
                .catch(() => {
                  // 处理请求错误
                  this.handleSiChuanError();
                });

            // 在这里执行验证通过后的逻辑
          } catch (error) {
            // 处理请求错误
            this.handleSiChuanError();
          }

        }
      } else {
        this.handleSiChuanError();
      }
    }
  },
  methods: {
    async registerSiChuan(idToken, target) {
      try {

        const response = await registerSiChuan({
          idToken: idToken,
          target: target,
          type: 1
        });
        console.log('response:',response); // 调试信息

        if (response.status == "200") {
          const userData = response.data;
          let id = userData.userId;
          let token = userData.token;
          const formData = new FormData();
          formData.append('email',id);
          formData.append('token', token);
          this.Login(formData).then(async () => {

            let res = await this.GetUserInfo();
            initDynamicRoutes();
            if (res.data.tenantId) {
              this.$router.push("/taxRiskControl");
            } else {
              this.$router.push("/dashboard");
            }
            this.$notification.success({
              message: "欢迎",
              description: `${timeFix()}，欢迎回来`,
            });
          })
              .catch((err) => {
                this.$message.error(err.msg);
              });
        }  else if ((response.status == "10021")) {
          //补录信息页面
          this.handleRegisterSiChuan();
        } else {
          // 处理其他错误状态码
          if (response.msg) {
            this.$error({
              title: '登录失败',
              content: response.msg,
              okText: '确定',
              centered: true,
            });
          } else {
            this.$error({
              title: '登录失败',
              content: '登录失败，请重试',
              okText: '确定',
              centered: true,
            });
          }
        }
      } catch (error) {
        // 处理请求错误
        this.handleSiChuanError();
      }
    },

    handleSiChuanError() {
      this.errorShowSiChuan = true;

      this.flag = true;
    },
    handleError() {
      this.errorShow = true;
      this.flag = true;
    },
    ...mapActions(["Login", "GetUserInfo"]),
    //点击登录
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let formdata = new FormData();
          for (let i in values) {
            formdata.append(i, values[i]);
          }
          this.Login(formdata)
              .then(async () => {
                let res = await this.GetUserInfo();
                initDynamicRoutes();
                if (res.data.tenantId) {
                  this.$router.push("/taxRiskControl");
                } else {
                  this.$router.push("/dashboard");
                }
                this.$notification.success({
                  message: "欢迎",
                  description: `${timeFix()}，欢迎回来`,
                });
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
        }
      });
    },
    handleRegister() {
      this.$refs.registerModal.show();
    },
    handleRegisterSiChuan() {
      this.$refs.registerModalSiChuan.show();
    },
    updatePassword() {
      this.$refs.updatePasswordModal.show();
    },
  },
  computed: {
    ...mapGetters(["tenantInfo"]),
  },
};
</script>

<style lang="less" scoped>
.modal-content {
  padding: 20px;
  text-align: center;
  background-color: #f5f5f5;
}
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
